import React, { Component, useEffect, useState } from "react";
import Form from "../../../comman/form";
import http from "../../../services/HttpService";
import config from "../../../config.json";
import { Link } from "react-router-dom";
import Joi from "joi-browser";
import Swal from "sweetalert2";
import useForm from "../../../app/hooks/useForm";
import useControls from "../../../app/hooks/useControls";
import { candidateUpdated, getCandidateUpatedStatus, updateNewCandidate } from "../../../app/store/candidate";
import { useDispatch, useSelector } from "react-redux";
import { getAlert } from "../../../services/appAlerts";
import { getApplicationData } from "../../../app/store/application";
import { getStateAdminData } from "../../../app/store/duration";

const Msp = (props) => {

  const { candidateObj, updateSelectedObject, setSelectedTabKey,
    actType, setSelectedCandidateId } = props;

  const stateAdminDataObj = useSelector(getStateAdminData)

  const mspMode = [
    { id: 101, name: "Not Applicable" },
    { id: 1, name: "Direct" },
    { id: 2, name: "MSP-DotStaff" },
    { id: 3, name: "MSP-ACRO" },
    { id: 4, name: "MSP-CAI" },
    { id: 5, name: "MSP-TAFFIN" },
    { id: 6, name: "Others" },
  ];

  const schema = {
    Msp_Mode: Joi.string().required().label("MSP Mode"),
  };

  const schema1 = {
    Msp_Contact1_Name: Joi.string().required().label("Name"),
    Msp_Contact1_Email: Joi.string()
      .email()
      .required()
      .label("Email Address")
      .allow(""),
    Msp_Contact1_Phone: Joi.string()
      .required()
      .length(10)
      .options({
        language: {
          string: {
            length: "Phone number must be 10 digits.",
          },
        },
      })
      .label("Phone Number"),
    Msp_Contact2_Name: Joi.string().required().label("Name"),
    Msp_Contact2_Email: Joi.string().email().required().label("Email Address"),
    Msp_Contact2_Phone: Joi.string()
      .required()
      .length(10)
      .options({
        language: {
          string: {
            length: "Phone number must be 10 digits.",
          },
        },
      })
      .label("Phone Number"),
  };

  const [aworkfinityApp, setAworkfinityApp] = useState(null);
  const [compName, setCompName] = useState("");
  const [agencyStateData, setAgencyStateData] = useState("");

  const candidateUpatedStatusSelector = useSelector(getCandidateUpatedStatus)

  const dispatch = useDispatch();

  useEffect(() => {
    if (candidateObj?.performerData) {
      const obj = getApplicationData(candidateObj.performerData);
      if (obj?.aWorkfinityApp) {
        setAworkfinityApp(obj.aWorkfinityApp);
        const appName = Object.keys(obj.aWorkfinityApp)[1];
        const aWorkfinityAppEntity = obj.aWorkfinityApp[appName];
        const mspData = aWorkfinityAppEntity["candidateonboardingform"];
        const data = {};
        if (mspData) {
          Object.keys(mspData).forEach(function (keyValue1) {
            if (keyValue1 !== "EntityId") {
              var item = mspData[keyValue1];
              if (!Array.isArray(item)) data[keyValue1.replace("@", "")] = item;
            }
          });
          setStateData(data);
        }
      }
    }
    else {
      setStateData({});
      setAworkfinityApp(null);
    }

  }, [candidateObj]);

  useEffect(() => {
    if (candidateObj?.performerData) {
      const obj = getApplicationData(candidateObj.performerData);
      if (obj?.aWorkfinityApp) {
        // setAworkfinityApp(obj.aWorkfinityApp);
        const appName = Object.keys(obj.aWorkfinityApp)[1];
        const aWorkfinityAppEntity = obj.aWorkfinityApp[appName];
        const agencyData = aWorkfinityAppEntity["projectengagement"];
        const data = {};
        if (agencyData) {
          Object.keys(agencyData).forEach(function (keyValue1) {
            if (keyValue1 !== "EntityId") {
              var item = agencyData[keyValue1];
              if (!Array.isArray(item)) data[keyValue1.replace("@", "")] = item;
            }
          });
          setAgencyStateData(data);
          // setUpdatedStateData(data);
        }
      }
    }
    // else {
    //   setStateData({});
    //   setAworkfinityApp(null);
    // }

  }, [candidateObj]);

  const doSubmit = () => {
    const NewAWorkfinityApp = { ...aworkfinityApp };
    const appName = Object.keys(NewAWorkfinityApp)[1];
    const aWorkfinityAppEntity = NewAWorkfinityApp[appName];
    const mspData = aWorkfinityAppEntity["candidateonboardingform"];
    Object.keys(stateData).forEach(function (keyValue) {
      mspData["@" + keyValue] = stateData[keyValue];
    });

    aWorkfinityAppEntity["candidateonboardingform"] = mspData;
    NewAWorkfinityApp[appName] = aWorkfinityAppEntity;
    const formData = new FormData();
    formData.append("appEntity", JSON.stringify(NewAWorkfinityApp));
    formData.append("recruiter", "");
    formData.append("subcontractor", "");
    formData.append("perfId", candidateObj.performerid);
    dispatch(updateNewCandidate(formData));
    setCompName("msp");
  }

  useEffect(() => {
    if (candidateUpatedStatusSelector && compName === "msp") {
      setCompName("");
      if (actType === "edit") {
        getAlert("", "Updated Successfully", "success");
      }
      else {
        getAlert("", "Added Successfully", "success");
      }

      updateSelectedObject(candidateObj.performerid, aworkfinityApp, "msp");

      dispatch(candidateUpdated(null));

      //setSelectedTabKey("home");
      //setSelectedCandidateId(0);

    }
  }, [candidateUpatedStatusSelector]);

  // const handleStateAdminOtherChange = (e) => {
  //   const { name, value } = e.target;
  //   setStateData((prev) => {
  //     const updatedState = { ...prev, [name]: value };
  //     console.log("updatedState", updatedState)
  //     const RatePayableIpcs = parseFloat(agencyStateData["RatePayableIpcs"]) || 0;
  //     const StateAdminFee = parseFloat(agencyStateData["State_Admin_Fee"]) || 0;
  //     const StateAdminFeeAmount = parseFloat(agencyStateData["State_Admin_Fee_Amount"]) || 0;
  //     const MspTechFee = parseFloat(updatedState.Msp_TechFee) || 0;
  //     const MspAdminFee = parseFloat(updatedState.Msp_AdminFee) || 0;
  //     const HubFee = parseFloat(updatedState.Hub_CompanyFee) || 0;

  //     let remainingRatePayable = RatePayableIpcs;

  //     if (StateAdminFee > 0) {
  //       const totalPercentage = StateAdminFee + MspAdminFee + HubFee;
  //       if (totalPercentage >= 100) {
  //         getAlert("Warning", `Invalid input: The total deductions exceed Rate Payable Ipcs`, "warning");
  //         return 
  //       }
  //       remainingRatePayable -= (totalPercentage / 100) * RatePayableIpcs;
  //     } else if (StateAdminFeeAmount > 0) {

  //       remainingRatePayable -= StateAdminFeeAmount;

  //       remainingRatePayable -= ((MspAdminFee + HubFee) / 100) * RatePayableIpcs;
  //     }

  //     remainingRatePayable -= MspTechFee;

  //     if (remainingRatePayable <= 0) {
  //       getAlert("Warning", `Invalid input: The total deductions exceed Rate Payable Ipcs`, "warning");
  //       return prev;
  //     }

  //     return updatedState;

  //   })
  // }
  const handleStateAdminOtherChange = (e) => {
    const { name, value } = e.target;

    // First, perform all validations before updating state
    const numericValue = parseFloat(value) || 0;

    // Create a temporary object with the potential new value
    const potentialNewState = { ...stateData, [name]: value };

    const RatePayableIpcs = parseFloat(agencyStateData["RatePayableIpcs"]) || 0;
    const StateAdminFee = parseFloat(agencyStateData["State_Admin_Fee"]) || 0;
    const StateAdminFeeAmount = parseFloat(agencyStateData["State_Admin_Fee_Amount"]) || 0;
    const MspTechFee = parseFloat(potentialNewState.Msp_TechFee) || 0;
    const MspAdminFee = parseFloat(potentialNewState.Msp_AdminFee) || 0;
    const HubFee = parseFloat(potentialNewState.Hub_CompanyFee) || 0;

    let remainingRatePayable = RatePayableIpcs;

    if (StateAdminFee > 0) {
      const totalPercentage = StateAdminFee + MspAdminFee + HubFee;
      if (totalPercentage >= 100) {
        getAlert("Warning", `Invalid input: The total deductions exceed Rate Payable Ipcs`, "warning");
        // Reset the input field value to previous state value
        e.target.value = stateData[name] || '';
        return;
      }
      remainingRatePayable -= (totalPercentage / 100) * RatePayableIpcs;
    } else if (StateAdminFeeAmount > 0) {
      remainingRatePayable -= StateAdminFeeAmount;
      remainingRatePayable -= ((MspAdminFee + HubFee) / 100) * RatePayableIpcs;
    }

    remainingRatePayable -= MspTechFee;

    if (remainingRatePayable <= 0) {
      getAlert("Warning", `Invalid input: The total deductions exceed Rate Payable Ipcs`, "warning");
      // Reset the input field value to previous state value
      e.target.value = stateData[name] || '';
      return;
    }

    // Only update state if validation passes
    setStateData(potentialNewState);
  }

  const { validate, handleChange, stateData, setStateData,
    stateErrors, setStateErrors, handleSubmit } = useForm(schema, doSubmit);

  const { renderSelect, renderInput, renderTextArea } = useControls(stateData, stateErrors, handleChange, schema);

  return (
    <div className="col-md-12">
      <div className="row">
        <div className="col-md-12">
          {renderSelect("Msp_Mode", "MSP Mode", mspMode, "name", "name")}
        </div>

        <div className={`${stateData?.Msp_Mode === "Others" ? "col-md-6" : "col-md-12"} mb-3`}>
          <label htmlFor="Msp_AdminFee" className="form-control-label">MSP Admin Fee %</label>
          <input
            type="number"
            name="Msp_AdminFee"
            id="Msp_AdminFee"
            className="form-control"
            placeholder="Msp AdminFee"
            onChange={handleStateAdminOtherChange}
            value={stateData["Msp_AdminFee"]}
            // disabled={!(parseInt(stateAdminDataObj["RatePayableIpcs"]) > 0)}
            min={0} />
        </div>

        {
          stateData?.Msp_Mode === "Others" &&
          <div className="col-md-6">
            {renderInput("MSP_Other_Mode", "MSP Other Detail")}
          </div>
        }

        <div className="col-md-12">
          <label
            htmlFor=""
            className="form-control-label bg-admin-light border-admin-left p-2 w-100"
          >
            MSP Contact 1
          </label>
        </div>
        <div className="col-md-4">
          {renderInput("Msp_Contact1_Name", "Name")}
        </div>
        <div className="col-md-4">
          {renderInput("Msp_Contact1_Email", "Email")}
        </div>
        <div className="col-md-4">
          {renderInput("Msp_Contact1_Phone", "Phone No.", "phone")}
        </div>
        <div className="col-md-12">
          <label
            htmlFor=""
            className="form-control-label bg-admin-light border-admin-left p-2 w-100"
          >
            MSP Contact 2
          </label>
        </div>
        <div className="col-md-4">
          {renderInput("Msp_Contact2_Name", "Name")}
        </div>
        <div className="col-md-4">
          {renderInput("Msp_Contact2_Email", "Email")}
        </div>
        <div className="col-md-4">
          {renderInput("Msp_Contact2_Phone", "Phone No.", "phone")}
        </div>
        <div className="col-md-12">
          {renderTextArea("mspNotes", "Notes")}
        </div>
        <div className="col-md-12">
          <label
            htmlFor=""
            className="form-control-label bg-admin-light border-admin-left p-2 w-100"
          >
            Other Fee
          </label>
        </div>
        {/* <div className="col-md-6 mb-3">
          <label htmlFor="Msp_TechFe" className="form-control-label">Tech Fee $/Hr</label>
          <input
            type="number"
            name="Msp_TechFee"
            id="Msp_TechFee"
            className="form-control"
            placeholder="Tech Fee $/Hr"
            onChange={handleStateAdminOtherChange}
            value={stateData["Msp_TechFee"]}
            // disabled={!(parseInt(stateAdminDataObj["RatePayableIpcs"]) > 0)}
            min={0} />
        </div> */}
        <div className="col-md-6 mb-3">
          <label htmlFor="Hub_CompanyFee" className="form-control-label">HUB Fee %</label>
          <input
            type="number"
            name="Hub_CompanyFee"
            id="Hub_CompanyFee"
            className="form-control"
            placeholder="HUB Fee %"
            onChange={handleStateAdminOtherChange}
            value={stateData["Hub_CompanyFee"]}
            // disabled={!(parseInt(stateAdminDataObj["RatePayableIpcs"]) > 0)}
            min={0} />
        </div>
        <div className="col-md-12 text-center form-group">
          {/* <button
            className="btn btn-sm btn-outline-default mb-2"
            disabled={validate()}
            onClick={() => handleSubmit("save")}
          >
            <i className="fa fa-check" aria-hidden="true"></i> Save
          </button>
          <br /> */}
          <button
            className="btn btn-sm btn-outline-default"
            disabled={validate()}
            onClick={handleSubmit}
          >
            <i className="fa fa-check" aria-hidden="true"></i> Save and Done
          </button>
        </div>
      </div>
    </div>
  );
}

export default Msp;
